import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  followVisitedProfile,
  unFollowVisitedProfile,
} from "../../redux/actions/visitedProfileActions";
import { updateFollowing } from "../../redux/actions/currentProfileActions";
import { useTranslation } from "react-i18next";
import { IonButton } from "@ionic/react";

const FollowBtn = ({ user, className = "" }) => {
  const { t } = useTranslation();
  const { data } = useSelector((state) => state.currentProfile);
  const dispatch = useDispatch();

  const handleFollow = () => {
    dispatch(followVisitedProfile(user.username)).then(() => {
      dispatch(updateFollowing({ profile: user, action: "follow" }));
    });
  };

  const handleUnfollow = () => {
    dispatch(unFollowVisitedProfile(user.username)).then(() => {
      dispatch(updateFollowing({ profile: user, action: "unfollow" }));
    });
  };

  const isFollowing = data.following.some(
    (followingUser) => followingUser.username === user.username,
  );

  // useEffect(() => {
  //   console.log("Current user following:", data.following);
  //   console.log("Profile:", user);
  //   console.log("Is following:", isFollowing);
  // }, [data.following, user, isFollowing]);

  // return isFollowing ? (
  //   <button className="unfollow-btn" onClick={handleUnfollow}>
  //     {t("following")}
  //   </button>
  // ) : (
  //   <button className="follow-btn" onClick={handleFollow}>
  //     {t("follow")}
  //   </button>
  // );
  // return isFollowing ? (
  //   <IonButton
  //     fill="solid"
  //     size="small"
  //     color="medium"
  //     onClick={handleUnfollow}
  //     className="following-button"
  //   >
  //     {t("following")}
  //   </IonButton>
  // ) : (
  //   <IonButton
  //     fill="solid"
  //     size="small"
  //     color="primary"
  //     onClick={handleFollow}
  //     className="follow-button"
  //   >
  //     {t("follow")}
  //   </IonButton>
  // );
  return isFollowing ? (
    <IonButton
      fill="outline"
      size="medium"
      color="dark" // makes it red
      onClick={handleUnfollow}
      className={`following-button ${className}`}
    >
      {t("following")}
    </IonButton>
  ) : (
    <IonButton
      fill="solid"
      size="medium"
      color="dark" // blue follow
      onClick={handleFollow}
      className={`follow-button ${className}`}
    >
      {t("follow")}
    </IonButton>
  );
};

export default FollowBtn;
